const getFlightHours = (timeString) => {
    const date = new Date(timeString);
    return date.getHours();
}

export default getFlightHours;